module.exports = __webpack_public_path__ + "img/IMG_8673_L_Foamcore.ad6c16a2.jpg";